import { Input, Component, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { KeyValue } from '@angular/common';

import { AppConstants } from '../../../../app.constants';
import { CustomFileModel } from '../../../../core/models/entities/file.type';
import { ILauncherFeature } from '../../../../core/interfaces/launcher-feature.interface';
import { Launcher } from '../../../../core/models/entities/launcher.type';
import { LauncherFeatureNameTypeEnum } from '../../../../core/models/enums/launcher-feature-name-type.enum';
import { LauncherFeatureTooltipTypeEnum } from '../../../../core/models/enums/launcher-feature-tooltip-type.enum';
import { PlaylistItemType } from '../../../../core/models/enums/playlist-item-type.enum';
import { PlaylistItemDTO } from '../../../../core/models/view-models/playlist-item-models/playlist-item-dto.model';
import { MawChromeLauncherViewMode } from '../../../../core/enums/mcl-view-mode.enum';
import { PlaylistDTO } from '../../../../core/models/view-models/playlist-models/playlist-dto.model';
import { PlaylistItemLinkModel } from '../../../../core/models/view-models/playlist-item-models/playlist-item-link.model';
import { PlaylistItemChangeSourceModel } from '../../../../core/models/view-models/playlist-item-models/playlist-item-change-source-model';
import { FilesService } from '../../../../core/services/http-services/files.service';
import { RssTickerConfigs } from '../../../../core/models/entities/rss-ticker.type';

@Component({
  selector: 'recent-file',
  templateUrl: './recent-file.component.html',
  styleUrls: [
    './recent-file.component.scss',
    '../../../modal-playlist-item/playlist-item-dialog.component.scss'
  ]
})
export class RecentFileComponent implements OnInit {
  @Input() playlist: PlaylistDTO
  @Input() File: CustomFileModel;
  @Input() files: CustomFileModel[] = [];
  @Input() launchers: Launcher[] = [];
  @Input() checkedPlaylists: number;
  @Input() playlistItems: PlaylistItemDTO[];
  @Input() hasRssForegroundItem: boolean;

  @Output() changeLauncher: EventEmitter<PlaylistItemChangeSourceModel> = new EventEmitter();
  @Output() setSelectedLauncherForAllItems: EventEmitter<Launcher> = new EventEmitter();
  @Output() isCheckedEvent: EventEmitter<number> = new EventEmitter();
  @Output() setDurationForAllItems: EventEmitter<string> = new EventEmitter();
  @Output() changeSourceField: EventEmitter<PlaylistItemChangeSourceModel> = new EventEmitter();
  @Output() changeSourceData: EventEmitter<PlaylistItemChangeSourceModel> = new EventEmitter();
  @Output() changeMCLMode: EventEmitter<PlaylistItemChangeSourceModel> = new EventEmitter();
  @Output() determineDuration: EventEmitter<PlaylistItemDTO> = new EventEmitter();
  @Output() zoomInputChanged: EventEmitter<PlaylistItemChangeSourceModel> = new EventEmitter();
  @Output() stretchContentChanged: EventEmitter<PlaylistItemDTO> = new EventEmitter();
  @Output() setLauncherByFileType: EventEmitter<PlaylistItemDTO> = new EventEmitter();

  IsChecked = false;
  Date: string;
  playlistItem: PlaylistItemDTO = null;
  ShowOptions = false;
  selectedLauncher: Launcher;
  mawChromeModes = MawChromeLauncherViewMode;
  playlistItemName: string;
  iconsPath = AppConstants.LAUNCHERS_ICONS_PATH;
  rssInputPlaceholder = AppConstants.RSS_INPUT_PLACEHOLDER;
  showApplyDurationOption: boolean;
  showSetLauncherOption: boolean;

  #filesService = inject(FilesService);

  ngOnInit(): void {
    this.Date = new Date(this.File.DateCreated).toLocaleDateString();
  }

  changed() {
    if (this.IsChecked) {
      this.playlistItem = new PlaylistItemDTO();
      this.selectedLauncher = null;

      this.playlistItem.PlaylistItemType = PlaylistItemType.RecentFile;
      this.playlistItem.PlaylistFileName = this.File.Title;
      this.playlistItem.PlaylistItemTitle = this.File.Title;
      this.playlistItem.Duration = this.File.Duration || AppConstants.DEFAULT_PLAYLIST_ITEM_DURATION;
      this.playlistItem.ExactVideoDuration = this.File.Duration;
      this.playlistItem.useExactDuration = true;

      const source = new PlaylistItemLinkModel();
      source.File = this.File;
      source.FileId = this.File.Id;
      source.IsFile = true;
      source.duration = this.File.Duration;
      this.playlistItem.PlaylistItemLinks.push(source);

      this.ShowOptions = true;
      this.playlistItems.push(this.playlistItem);
      this.#filesService.previewContent(this.playlistItem);
      this.isCheckedEvent.emit(1);

      if (this.playlist.IsAndroid) {
        this.playlistItem.RssConfigs = new RssTickerConfigs();
      }
      else {
        this.setDefaultLauncher();
      }
    } else {
      this.isCheckedEvent.emit(-1);
      this.playlistItem = null;
      this.ShowOptions = false;
      this.showApplyDurationOption = false;
      this.showSetLauncherOption = false;
      this.selectedLauncher = null;
    }
  }

  onExactDurationChange(isChecked: boolean) {
    this.playlistItem.Duration = isChecked
      ? this.playlistItem.ExactVideoDuration || this.File.Duration
      : AppConstants.DEFAULT_PLAYLIST_ITEM_DURATION;
  }

  onLauncherChanged(): void {
    this.playlistItem.LauncherId = this.selectedLauncher.Id;
    this.showSetLauncherOption = true;

    const source = new PlaylistItemChangeSourceModel();
    source.item = this.playlistItem;
    source.launcher = this.selectedLauncher;

    this.changeLauncher.emit(source);
  }

  onChangeMode(selectedMode: string): void {
    const source = new PlaylistItemChangeSourceModel();
    source.item = this.playlistItem;
    source.mclMode = selectedMode;

    this.changeMCLMode.emit(source);
  }

  onChangeField(index: number): void {
    const source = new PlaylistItemChangeSourceModel();
    source.item = this.playlistItem;
    source.sourceId = index;

    this.changeSourceField.emit(source);
  }

  onSourceChanged(index: number, e: Event): void {
    const source = new PlaylistItemChangeSourceModel();
    source.item = this.playlistItem;
    source.sourceId = index;
    source.event = e;

    this.changeSourceData.emit(source);
  }

  onDurationChanged(item: PlaylistItemDTO) {
    this.showApplyDurationOption = true;
    item.useExactDuration = false;
  }

  onZoomInputChanged(event: Event, index: number) {
    const source = new PlaylistItemChangeSourceModel();
    source.item = this.playlistItem;
    source.sourceId = index;
    source.event = event;

    this.zoomInputChanged.emit(source);
  }

  public clear(): void {
    this.playlistItem = null;
    this.IsChecked = false;
    this.ShowOptions = false;
  }

  public getFeatureName(launcherFeature: ILauncherFeature): string {
    return LauncherFeatureNameTypeEnum[launcherFeature.FeatureKey];
  }

  public getFeatureTooltip(launcherFeature: ILauncherFeature): string {
    return LauncherFeatureTooltipTypeEnum[launcherFeature.FeatureKey];
  }

  public valueAscOrder(a: KeyValue<number,string>, b: KeyValue<number,string>): number {
    return a.value.localeCompare(b.value);
  }

  private setDefaultLauncher() {
    this.setLauncherByFileType.emit(this.playlistItem);
    this.selectedLauncher = this.playlistItem.Launcher;
  }
}
